import QueryProvider from './query.js';
import { SquashGameContextProvider } from './squashGameState.js';
import TRPCProvider from './trpc.js';
import { PuzzleWalletProvider } from '@puzzlehq/sdk';

const RootProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PuzzleWalletProvider>
      <TRPCProvider>
        <QueryProvider>
          <SquashGameContextProvider>{children}</SquashGameContextProvider>
        </QueryProvider>
      </TRPCProvider>
    </PuzzleWalletProvider>
  );
};

export default RootProvider;
